export const headerData = [
  {
    image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item40.jpg?v=1600242275',
    altText: 'Winter Spice',
    title: 'Winter Spice HW20',
    cap_image:
      'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/1_09616c1c-ffb8-4824-8c8b-879c5323f064.jpg?v=1600143766',
  },
];

export const w1Data = [
  {
    image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/img2.jpg?v=1600143766',
    altText: 'stehkragen-strickjacke-mit-reissverschluss-decadent-chocolate',
    handle: '/products/stehkragen-strickjacke-mit-reissverschluss-decadent-chocolate',
    btn: 'Jetzt entdecken',
    description:
      'Der Herbst ist vielleicht die schönste Zeit des Jahres. Sein Markenzeichen, weicher und kuscheliger Pullover, macht ihn großartiger.  ',
    style: ' c-hide',
    w1Child: [
      {
        image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/img3.jpg?v=1600143766',
        altText: 'pullover-mit-reissverschluss-an-der-schulter-black-plum',
        btn: 'Jetzt entdecken',
        handle: '/products/pullover-mit-reissverschluss-an-der-schulter-black-plum',
        style: ' c-hide',
      },
      {
        image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/img4.jpg?v=1600143766',
        altText: 'pullover-mit-pointelle-muster-pale-mauve',
        btn: 'Jetzt entdecken',
        handle: '/products/pullover-mit-pointelle-muster-pale-mauve',
        style: ' c-hide',
      },
    ],
    w1Child2: [
      {
        image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/img5.jpg?v=1600143766',
        altText: 'pullover-mit-kordelzug-cowhide',
        btn: 'Jetzt entdecken',
        handle: '/products/pullover-mit-kordelzug-cowhide',
        style: ' c-hide',
      },
      {
        image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/img6.jpg?v=1600143766',
        altText: 'strukturierter-rundhalspullover-buttercream',
        btn: 'Jetzt entdecken',
        handle: '/products/strukturierter-rundhalspullover-buttercream',
        style: ' c-hide',
      },
    ],
  },
];
export const w2Data = [
  {
    image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item7.jpg?v=1600143765',
    altText: 'pullover-mit-seitenknopfen-old-rose',
    handle: '/products/pullover-mit-seitenknopfen-old-rose',
    btn: 'Jetzt entdecken',
    description: `Praktische Details gestalten den  wärmsten und begehrtesten Stoff der Welt neu.`,
    style: ' c-hide',
    w2Child: [
      {
        image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item8.jpg?v=1600143766',
        altText: 'stehkragenpullover-black-plum',
        btn: 'Jetzt entdecken',
        handle: '/products/stehkragenpullover-black-plum',
        style: ' c-hide',
      },
    ],
  },
];
export const w3Data = [
  {
    image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item11.jpg?v=1600143765',
    altText: 'Winter Spice',
    handle: '/products/kurzer-mantel-mit-kapuze-mandel',
    btn: 'Jetzt entdecken',
    style: ' c-hide',
    style2: ' ',
  },
  {
    image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item12.jpg?v=1600143766',
    altText: 'wendemantel-mit-drapiertem-kragen-verbrannte-henna',
    handle: '/products/wendemantel-mit-drapiertem-kragen-verbrannte-henna',
    btn: 'Jetzt entdecken',
    style: ' c-hide',
    style2: ' m-grid',
  },
  {
    image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item10.jpg?v=1600143766',
    altText: 'langer-schalkragen-mantel-rum-rosine',
    handle: '/products/langer-schalkragen-mantel-rum-rosine',
    btn: 'Jetzt entdecken',
    style: ' c-hide',
    style2: ' img-box-bottom',
  },
];

export const w4Data = [
  {
    title: 'MÄNTEL ZUM ÜBERZIEHEN',
    w4Child: [
      {
        image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item11.jpg?v=1600143765',
        altText: 'kurzer-mantel-mit-kapuze-mandel',
        handle: '/products/kurzer-mantel-mit-kapuze-mandel',
        btn: 'Jetzt entdecken',
        style: ' c-hide',
        style2: ' pad-right-100',
      },
      {
        image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item12.jpg?v=1600143766',
        altText: 'wendemantel-mit-drapiertem-kragen-verbrannte-henna',
        handle: '/products/wendemantel-mit-drapiertem-kragen-verbrannte-henna',
        btn: 'Jetzt entdecken',
        style: ' c-hide',
        style2: ' pad-left-100',
      },
    ],
  },
];

export const w5Data = [
  {
    image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item14.jpg?v=1600143764',
    altText: 'mittellanger-rock-pale-mauve',
    handle: '/products/mittellanger-rock-pale-mauve',
    btn: 'Jetzt entdecken',
    description:
      'Bereiten Sie Ihre Röcke und Kleider für den Herbst vor. Die langen Ärmel und Säume werden Sie warm halten, wenn es draussen frisch wird.',
    style: ' c-hide',
    w5Child: [
      {
        image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item18.jpg?v=1600143766',
        altText: 'midikleid-mit-v-ausschnitt-toasted-almond',
        handle: '/products/midikleid-mit-v-ausschnitt-toasted-almond',
        btn: 'Jetzt entdecken',
        style: ' c-hide',
      },
      {
        image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item17.jpg?v=1600143766',
        altText: 'midikleid-mit-kapuze-toasted-almond',
        handle: '/products/midikleid-mit-kapuze-toasted-almond',
        btn: 'Jetzt entdecken',
        style: ' c-hide',
      },
    ],
    w5Child2: [
      {
        image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item21.jpg?v=1600143766',
        altText: 'midikleid-mit-v-ausschnitt-toasted-almond',
        handle: '/products/dicker-pullunder-cowhide',
        btn: 'Jetzt entdecken',
        style: ' c-hide',
      },
      {
        image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item19.jpg?v=1600143766',
        altText: 'kapuzenpullover-mit-kordelzug-old-rose',
        handle: '/products/kapuzenpullover-mit-kordelzug-old-rose',
        btn: 'Jetzt entdecken',
        style: ' c-hide',
      },
    ],
    w5Child3: [
      {
        image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item15.jpg?v=1600143765',
        altText: 'midikleid-mit-v-ausschnitt-toasted-almond',
        handle: '/products/midikleid-mit-v-ausschnitt-toasted-almond',
        btn: 'Jetzt entdecken',
        style: ' c-hide',
      },
    ],
  },
];

export const w8Data = [
  {
    title: 'KUSCHELIGE LOUNGEWEAR',
    w8Child: [
      {
        image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item25.jpg?v=1600143763',
        altText: 'gerade-jogginghose-decadent-chocolate',
        handle: '/products/gerade-jogginghose-decadent-chocolate',
        btn: 'Jetzt entdecken',
        style2: ' pad-right-100',
        style: ' c-hide',
      },
      {
        image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item26.jpg?v=1600143766',
        altText: 'stehkragen-pullover-mit-kordelzug-decadent-chocolate',
        handle: '/products/stehkragen-pullover-mit-kordelzug-decadent-chocolate',
        btn: 'Jetzt entdecken',
        style2: ' pad-left-100',
        style: ' c-hide',
      },
    ],
  },
];

//Men data

export const m5Data = [
  {
    image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item27.jpg?v=1600143766',
    altText: 'kapuzenpullover-mit-streifen-decadent-chocolate',
    handle: '/products/kapuzenpullover-mit-streifen-decadent-chocolate',
    btn: 'Jetzt entdecken',
    description:
      'Die Pläne absagen und in gemütlicher Loungewear einkuscheln. Sie sieht so gut aus, dass Sie sie zum Ausleiern tragen können!',
    style: ' c-hide',
    m5Child: [
      {
        image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item29.jpg?v=1600143765',
        altText: 'kapuzen-strickjacke-mit-reissverschluss-decadent-chocolate',
        handle: '/products/kapuzen-strickjacke-mit-reissverschluss-decadent-chocolate',
        btn: 'Jetzt entdecken',
        style: ' c-hide',
      },
      {
        image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item30.jpg?v=1600143765',
        altText: 'zip-hoodie-decadent-chocolate',
        handle: '/products/kapuzen-strickjacke-mit-reissverschluss-decadent-chocolate',
        btn: 'Jetzt entdecken',
        style: ' c-hide',
      },
    ],
    m5Child2: [
      {
        image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item31.jpg?v=1600143767',
        altText: 'venice-rollkragenpullover-mit-zopfmuster-black-plum',
        handle: '/products/venice-rollkragenpullover-mit-zopfmuster-black-plum',
        btn: 'Jetzt entdecken',
        style: ' c-hide',
      },
      {
        image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item32.jpg?v=1600143766',
        altText: 'stehkragenpullover-mit-streifen-decadent-chocolate',
        handle: '/products/stehkragenpullover-mit-streifen-decadent-chocolate',
        btn: 'Jetzt entdecken',
        style: ' c-hide',
      },
    ],
    m5Child3: [
      {
        image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item28.jpg?v=1600143765',
        altText: 'kapuzenpullover-mit-streifen-decadent-chocolate',
        handle: '/products/kapuzenpullover-mit-streifen-decadent-chocolate',
        btn: 'Jetzt entdecken',
        style: ' c-hide',
      },
    ],
  },
];

export const m4Data = [
  {
    title: 'ÜBERGANGS-MÄNTEL',
    m4Child: [
      {
        image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item37.jpg?v=1600143765',
        altText: 'caban-mantel-mit-stehkragen-mandel',
        handle: '/products/caban-mantel-mit-stehkragen-mandel',
        btn: 'Jetzt entdecken',
        style2: ' pad-right-100',
        style: ' c-hide',
      },
      {
        image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item39_2.jpg?v=1600241933',
        altText: 'caban-mantel-mit-stehkragen-rum-rosine',
        handle: '/products/caban-mantel-mit-stehkragen-rum-rosine',
        btn: 'Jetzt entdecken',
        style2: ' pad-left-100',
        style: ' c-hide',
      },
    ],
  },
];
